import type { IncidentDetail } from '../types';

const isStatusChangeUnmergedEvent = (incident: IncidentDetail): boolean =>
  incident.events.some((event) => {
    if (event.type !== 'STATUS_CHANGE') {
      return false;
    }
    const reason = (event.data as Record<string, unknown> | null)?.reason;
    return reason === 'Unmerged';
  });

export const isFullyUnmergedIncident = (
  incident: IncidentDetail | null | undefined,
): boolean =>
  !!incident &&
  !incident.mergedIntoId &&
  incident.status === 'RESOLVED' &&
  incident.monitors.length === 0 &&
  isStatusChangeUnmergedEvent(incident);

export const isIncidentReadOnly = (
  incident: IncidentDetail | null | undefined,
): boolean =>
  !!incident && (!!incident.mergedIntoId || isFullyUnmergedIncident(incident));
